import { ScriptSelector } from "@/domain/main-header/entity/ScriptSelector.enum";
import { LogoDTO } from "@/domain/main-header/dto";
import { MainHeaderApplicationDataProvider } from "@/domain/main-header/application/MainHeaderApplicationData.provider";
import { IMainHeader } from "@/domain/main-header/entity/MainHeader.interface";

export class LogoConfigurationProvider {
    public static provideTo(mainHeaderApplicationData: Partial<IMainHeader>): Partial<IMainHeader> {
        const logoData = MainHeaderApplicationDataProvider.hasProvidedDataFor(ScriptSelector.LOGO) ?
            MainHeaderApplicationDataProvider.parseProvidedData<LogoDTO>(ScriptSelector.LOGO)
            : null;

        if (!logoData) {
            return mainHeaderApplicationData;
        }

        mainHeaderApplicationData.logo = this.normalizeLogoData(logoData);

        return mainHeaderApplicationData
    }

    private static normalizeLogoData(data: LogoDTO): LogoDTO {
        return {
            description: data.description ?? '',
            imgPath: data.imgPath ?? '',
            name: data.name ?? '',
            url: data.url ?? '',
            isSvg: data.isSvg ?? false,
        }
    }
}